import { useCallback, useEffect, useState } from 'react';
import {
  defaultAppOf, defaultRunnableOf, loadDefaultApp, saveDefaultApp, subscribeDefaultApp,
} from '../utils/defaultApp';

const current = (projectId) => ({ name: defaultAppOf(projectId), runnable: defaultRunnableOf(projectId) });

/**
 * The project's default app (utils/defaultApp.js): `{ defaultApp, defaultRunnable, setDefaultApp }`; `defaultApp` is a
 * short name or null (a pinned file's runner name, `app--compose-docker-compose-yaml`, when the default app is one),
 * `defaultRunnable` that file (`{ service, kind, file }`) or null. `setDefaultApp(name, { runnable })` saves it.
 * `enabled: false` reads nothing (a list row with no running app has nothing to open).
 */
export default function useDefaultApp(projectId, { enabled = true } = {}) {
  const [value, setValue] = useState(() => current(projectId));
  useEffect(() => {
    if (!projectId || !enabled) { setValue(projectId ? current(projectId) : { name: null, runnable: null }); return undefined; }
    setValue(current(projectId));
    const unsubscribe = subscribeDefaultApp(projectId, (name, runnable) => setValue({ name, runnable: runnable || null }));
    loadDefaultApp(projectId);
    return unsubscribe;
  }, [projectId, enabled]);
  const setDefaultApp = useCallback((service, options) => saveDefaultApp(projectId, service, options), [projectId]);
  return { defaultApp: value.name, defaultRunnable: value.runnable, setDefaultApp };
}
